import React, { useState } from "react";
import { toast } from "react-toastify";
import { checkSim, getSimShopee } from "../../api/checksim";

const CheckSim = () => {
  return (
    <div className="w-screen h-screen flex flex-col justify-between items-center">
      {/* Header */}
      <header className="py-4 text-white text-2xl bg-gray-800 w-full text-center">
        Check Sim Shopee
      </header>
      <div className="flex flex-col items-center justify-center">
        <div>Check sim bản web hiện đã ngưng hoạt động</div>
        <div>Mọi người sử dụng bản PC để được hỗ trợ dịch vụ tốt nhất nha</div>
        <div>Liên hệ mua ở nhóm Xtool</div>
        <div>Em cảm ơn mn nhiều ạ</div>
      </div>
      {/* Footer */}
      <footer className="py-4 text-white bg-gray-800 w-full text-center">
        © 2024 AutoPee. All rights reserved.
      </footer>
    </div>
  );
};

export default CheckSim;
